export default __webpack_public_path__ + "static/media/dollar.2c4e6464.svg";